import {ActionIcon, TextInput, TextInputProps} from "@mantine/core";
import {IconX} from "@tabler/icons-react";

export type DataTableTextFilterProps = Pick<TextInputProps, 'label' | 'description' | 'placeholder'> & {
  query?: string
  setQuery: (query: string | undefined) => void
}

export const DataTableTextFilter = (props: DataTableTextFilterProps) => {
  const {
    query,
    setQuery,
    ...rest
  } = props

  return (
    <TextInput
      {...rest}
      rightSection={
        <ActionIcon size="sm" variant="transparent" c="dimmed" onClick={() => setQuery(undefined)}>
          <IconX size={14}/>
        </ActionIcon>
      }
      value={query}
      onChange={(e) => setQuery(e.currentTarget.value)}
    />
  )
}
